import * as React from 'react';
import _ from 'lodash';
import clsx from 'clsx';

interface Props {
  selectedSize: string;
  onSelect(event: React.MouseEvent<HTMLElement>): void;
}

const options = [
  {
    label: 'Sm',
    value: '2',
  },
  {
    label: 'Med',
    value: '3',
  },
  {
    label: 'Lrg',
    value: '4',
  },
];

const TablePopoverVisualSizeSelector = (props: Props) => {
  return (
    <div className="TablePopoverVisualSizeSelector">
      {_.map(options, (option) => {
        const className = clsx('TablePopoverVisualSizeSelector-option', {
          'is-selected': option.value === props.selectedSize,
        });

        return (
          <div
            className={className}
            data-name={option.value}
            key={option.value}
            onClick={props.onSelect}
          >
            {option.label}
          </div>
        );
      })}
    </div>
  );
};

export default TablePopoverVisualSizeSelector;
